import { ALIGNMENT } from 'prose-core'
import { useAlignButtonToggle } from 'common/Prose/Toolbar/hooks/useAlignButtonToggle'
import { SingleMenuDropdownItem } from '../SingleMenuDropdown/SingleMenuDropdownItem'
import { observer } from 'mobx-react-lite'
import { IconName, ToolbarIcon } from 'common/Prose/Toolbar/ToolbarIcon'

export const AlignRightButton = observer(() => {
  const { active, handleClick } = useAlignButtonToggle(ALIGNMENT.Right)

  return (
    <SingleMenuDropdownItem
      icon={<ToolbarIcon name={IconName.AlignRight} />}
      label="Right"
      ariaLabel="Align right"
      active={active}
      handleClick={handleClick}
    />
  )
})
